import React from "react";
import Slot from "../Slot";
import Break from "../Break";
import StripedTypeLeave from "../StripedTypeLeave";

const ShowSlotsTimeClock = ({ useTimerClockSlots = [], data_day }) => {
    const data = useTimerClockSlots.at(0).at(1);
    const shifts = data?.shifts ?? [];
    const day_shifts = data_day.shifts;

    const isLeave = data_day?.type?.value === 2;
    return (
        <>
            {isLeave ? (
                <StripedTypeLeave
                    leave_name={data_day?.type?.leave_name}
                    background_color={data_day?.type?.leave_color}
                    striped_color={data_day?.type?.leave_color}
                    is_pending_leave={data_day?.type?.is_pending_leave}
                />
            ) : (
                <>
                    {day_shifts.map((shift, index) => {
                        const isLeave = shift?.type?.value === 1;
                        const is_shift_pending_leave =
                            shift?.type?.is_pending_leave;
                        if (isLeave) {
                            return (
                                <StripedTypeLeave
                                    leave_name={shift.type.leave_name}
                                    background_color={shift.type.leave_color}
                                    striped_color={shift.type.leave_color}
                                    is_half_day
                                    is_pending_leave={is_shift_pending_leave}
                                />
                            );
                        }
                    })}
                    {
                        // show slots
                        shifts.map((shift, index) => {
                            const isLastItem = index === shifts.length - 1;
                            const isLastItemBreak =
                                shift.type?.value === -1 && isLastItem;

                            const isBreak = shift?.type?.value === -1;

                            // c'est une pause
                            if (isBreak) {
                                return (
                                    <Break
                                        duration={shift.duration_str}
                                        isSlotsTimeClock={true}
                                        is_paused={
                                            data.is_paused && isLastItemBreak
                                        }
                                    />
                                );
                            }
                            // slots
                            return (
                                <Slot
                                    status={
                                        data.is_paused || isLastItemBreak
                                            ? "clocktime_paused"
                                            : "clocktime_start"
                                    }
                                    start_time={shift.start_time}
                                    end_time={shift.end_time}
                                    duration={shift.duration_str ?? "--h--"}
                                    isSlotsTimeClock={true}
                                    isPaused={data.is_paused}
                                    isOnsite={shift.is_on_site}
                                    isLastItemBreak={isLastItemBreak}
                                />
                            );
                        })
                    }
                </>
            )}
        </>
    );
};

export default ShowSlotsTimeClock;
